import Vue from "vue";
import Router from "vue-router";
import JobService from 'Container/JobService';
import Service from 'Container/Service';
import Organization from 'Container/Organization';
import Agency from 'Container/Agency';
// import cognito from "@/cognito";
import store from '.././store'
import axios from 'axios';
import { AmplifyEventBus } from 'aws-amplify-vue'
import * as AmplifyModules from 'aws-amplify'
import { AmplifyPlugin } from 'aws-amplify-vue'
import Amplify from 'aws-amplify'
import awsconfig from '../aws-exports'

// view直下系
const Top = () => import('Views/Top');
const Callback = () => import('Views/Callback');

// view/other系
const StudyText = () => import('Views/other/StudyText');
const Deactivate = () => import('Views/other/Deactivate');
const TermService = () => import('Views/other/TermService');
const SpecificCommerce = () => import('Views/other/SpecificCommerce');
const PrivacyPolicy = () => import('Views/other/PrivacyPolicy');
const Qa = () => import('Views/other/Qa');
const MoveList = () => import('Views/other/MoveList');

//User系
const Mypage = () => import('Views/user/Mypage');
const News = () => import('Views/user/News');
const NewsDetail = () => import('Views/user/NewsDetail');
const Examination = () => import('Views/user/Examination');
const ExaminationDetail = () => import('Views/user/ExaminationDetail');
const PastExam = () => import('Views/user/PastExam');
const Boards = () => import('Views/user/thread/Boards');
const BoardDetail = () => import('Views/user/thread/BoardDetail');
const JobHowToUse = () => import('Views/user/JobHowToUse');

// User/quiz系
const TryQuiz = () => import('Views/user/quiz/TryQuiz');
const PastedQuizList = () => import('Views/user/quiz/PastedQuizList');
const PastedQuiz = () => import('Views/user/quiz/PastedQuiz');

// User/session系
const AccountSetting = () => import('Views/user/session/AccountSetting');
const EmailSetting = () => import('Views/user/session/EmailSetting');
const PasswordSetting = () => import('Views/user/session/PasswordSetting');
const ProfileSetting = () => import('Views/user/session/ProfileSetting');
const AcceptCertificate = () => import('Views/user/session/AcceptCertificate');
const ResumeUpload = () => import('Views/user/session/ResumeUpload');
const CreateUser = () => import('Views/user/session/CreateUser');
const Payment = () => import('Views/user/session/Payment');
const SucceedPayment = () => import('Views/user/session/SucceedPayment');
const VisaApplication = () => import('Views/user/session/VisaApplication');

// organization/session系
const organizationTop = () => import('Views/organization/OrganizeTop')
const Signin = () => import('Views/organization/session/Signin')
const Signup = () => import('Views/organization/session/Signup')
const Startup = () => import('Views/organization/session/Startup')
const Logout = () => import('Views/organization/Logout')

//Org系
const OrgMypage = () => import('Views/organization/Mypage')
const AddOrganizationInfo = () => import('Views/organization/AddOrganizationInfo')
//Org/offer系
const OrgCreateJobOffer = () => import('Views/organization/offer/CreateJobOffer')
const OrgJobOffers = () => import('Views/organization/offer/JobList')
const OrgJob= () => import('Views/organization/offer/Job')
const OrgJobPreview= () => import('Views/organization/offer/Preview')
const OrgMailBox = () => import('Views/organization/chat/MailBox');
const Interview = () => import('Views/organization/interview/Interview');
const UserInterview = () => import('Views/organization/interview/UserInterview');


// users/jobs系
const JobMypage = () => import('Views/user/JobMypage');
const Jobs = () => import('Views/user/jobs/Jobs');
const JobsSearch = () => import('Views/user/jobs/Search');
const JobDetail = () => import('Views/user/jobs/JobDetail');
const ApplicationJob = () => import('Views/user/jobs/ApplicationJob');

const Recruits = () => import('Views/user/recruits/Recruits');
const MailBox = () => import('Views/user/chat/MailBox');
const SeekerInterview = () => import('Views/user/interview/Interview');
const Resume = () => import('Views/user/jobs/Resume');

// 求職者検索系
const JobSeekerList = () => import('Views/organization/job_seeker/JobSeekerList')
const JobSeeker = () => import('Views/organization/job_seeker/JobSeeker')
const Favorites = () => import('Views/organization/job_seeker/Favorites')

// 応募者関系
const ApplicantList = () => import('Views/organization/applicant/ApplicantList')
const MatchList = () => import('Views/organization/applicant/MatchList')

// 企業側代理店関係
const AgencyList = () => import('Views/organization/agency/AgencyList')

// 代理店関係
const AgencyTop = () => import('Views/agency/AgencyTop')
const AgencyStartup = () => import('Views/agency/session/Startup')
const AgencyMypage = () => import('Views/agency/Mypage')
const CreateLink = () => import('Views/agency/CreateLink')
const AgencyLinkList = () => import('Views/agency/LinkList')
const AgencyUserList = () => import('Views/agency/UserList')
const AgencyUser = () => import('Views/agency/User')
const AgencyUserImport = () => import('Views/agency/UserImport')
const AgencyLogout = () => import('Views/agency/Logout')

Vue.use(Router)
Vue.use(AmplifyPlugin, AmplifyModules)

let user;

function getUser() {
    return Vue.prototype.$Amplify.Auth.currentAuthenticatedUser().then((data) => {
        if (data && data.signInUserSession) {
            localStorage.idToken = data.signInUserSession.accessToken.jwtToken
            store.commit('user/setUserOuth', data);
            return data;
        }
    }).catch(() => {
        store.commit('user/setUserOuth', null);
        return null;
    });
}

function getStaff() {
     awsconfig.aws_user_pools_id = process.env.VUE_APP_AWS_POOLS_ID_BUSINESS
    awsconfig.aws_user_pools_web_client_id = process.env.VUE_APP_AWS_WEB_CLIENT_ID_BUSINESS
    awsconfig.oauth.domain = process.env.VUE_APP_AWS_DOMAIN_BUSINESS
    awsconfig.oauth.redirectSignIn = process.env.VUE_APP_AWS_REDIRECT_URL
    awsconfig.oauth.redirectSignOut = process.env.VUE_APP_AWS_REDIRECT_URL
    awsconfig.oauth.responseType = process.env.VUE_APP_AWS_RESPONSETYPE
    Amplify.configure(awsconfig)
    return Vue.prototype.$Amplify.Auth.currentAuthenticatedUser().then((data) => {
        if (data && data.signInUserSession) {
            localStorage.idToken = data.signInUserSession.accessToken.jwtToken
            store.commit('staff/setStaffOuth', data);
            return data;
        }
    }).catch(() => {
        store.commit('staff/setStaffOuth', null);
        return null;
    });
}

function getAgencyStaff() {
    awsconfig.aws_user_pools_id = process.env.VUE_APP_AWS_POOLS_ID_BUSINESS
    awsconfig.aws_user_pools_web_client_id = process.env.VUE_APP_AWS_WEB_CLIENT_ID_BUSINESS
    awsconfig.oauth.domain = process.env.VUE_APP_AWS_DOMAIN_BUSINESS
    awsconfig.oauth.redirectSignIn = process.env.VUE_APP_AWS_REDIRECT_URL
    awsconfig.oauth.redirectSignOut = process.env.VUE_APP_AWS_REDIRECT_URL
    awsconfig.oauth.responseType = process.env.VUE_APP_AWS_RESPONSETYPE
    Amplify.configure(awsconfig)
    return Vue.prototype.$Amplify.Auth.currentAuthenticatedUser().then((data) => {
        if (data && data.signInUserSession) {
            localStorage.idToken = data.signInUserSession.accessToken.jwtToken
            store.commit('agencystaff/setStaffOuth', data);
            return data;
        }
    }).catch(() => {
        store.commit('agencystaff/setStaffOuth', null);
        return null;
    });
}

// ログイン状態管理
AmplifyEventBus.$on('authState', async (state) => {
    if (state === 'signedOut'){
        user = null;
        localStorage.idToken = ""
        store.commit('user/setUserOuth', null);
        this.$router.push({path: '/login'});
    } else if (state === 'signedIn') {
        user = await getUser();
        this.$router.push({path: '/mypage'});
    }
});


// リダイレクト設定
const requireAuth = async (to, from, next) => {
  user = await getUser();
  if (!user) {
    localStorage.idToken = ""
    return next({ path: '/'});
  }
  await axios
    .get(process.env.VUE_APP_API + "/users/callback", {headers: {'Authorization': 'Bearer ' + user.signInUserSession.accessToken.jwtToken}})
    .then(response => {
      localStorage.idToken = user.signInUserSession.accessToken.jwtToken
      store.commit('user/setUser', response.data)
    }).catch(error => {
      console.log('this is error', error)
    })
  return next()
};

// リダイレクト設定
const requireOrgAuth = async (to, from, next) => {
  user = await getStaff();
  if (!user) {
    localStorage.idToken = ""

    return next({ path: '/agency'});
  }
  await axios
  .get(process.env.VUE_APP_API + "api/staff/callback", {headers: {'Authorization': 'Bearer ' + user.signInUserSession.accessToken.jwtToken}})
  .then(response => {
    localStorage.idToken = user.signInUserSession.accessToken.jwtToken
    store.commit('staff/setStaff', response.data.staff)
  }).catch(error => {
    console.log('this is error', error)
  })
  return next()
};

// リダイレクト設定
const requireAgencyAuth = async (to, from, next) => {
  user = await getAgencyStaff();
  if (!user) {
    localStorage.idToken = ""
    console.log('not auth')
    return next({ path: '/agency'});
  }

  await axios
    .get(process.env.VUE_APP_API + "api/agency_staffs/callback", {headers: {'Authorization': 'Bearer ' + user.signInUserSession.accessToken.jwtToken}})
    .then(() => {
      console.log('hoge')
      // localStorage.idToken = user.signInUserSession.accessToken.jwtToken
      // store.commit('agencystaff/setStaff', response.data.staff)
      console.log('hoge')
    }).catch(error => {
      console.log('this is error', error)
    })
  return next()
};

export default new Router({
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [
  {path: "/",
  component: Service,

  children: [
  {
    path: '',
    name: "Top",
    components: {default: Top }
  },
  {
    path: '/createuser',
    name: "createUser",
    components: {default: CreateUser },
    beforeEnter: requireAuth
  },
  // {
  //   path: '/logout',
  //   beforeEnter: logout
  // },
  {
    path: '/mypage',
    name: 'Mypage',
    component: Mypage,
    beforeEnter: requireAuth
  },
  {
    path: '/quiz',
    name: 'tryquiz',
    component: TryQuiz,
    beforeEnter: requireAuth
  },
  {
    path: '/past-exam',
    name: 'pastExam',
    component: PastExam,
    beforeEnter: requireAuth
  },
  {
    path: '/examinations',
    name: 'examinations',
    component: Examination,
    beforeEnter: requireAuth
  },
  {
    path: '/examination/:id',
    name: 'examination',
    component: ExaminationDetail,
    beforeEnter: requireAuth
  },
  {
    path: '/pastedQuiz/:qId',
    name: 'pasted_quiz',
    component: PastedQuiz,
    beforeEnter: requireAuth
  },
  {
    path: '/pastedQuizList',
    name: 'pasted_quiz_list',
    component: PastedQuizList,
    beforeEnter: requireAuth
  },
  {
    path: '/payment',
    name: 'payment',
    component: Payment,
    beforeEnter: requireAuth
  },
  {
    path: '/succeedPayment',
    name: 'succeedPayment',
    component: SucceedPayment,
    beforeEnter: requireAuth
  },
  {
    path: '/profile_setting',
    name: 'profile_setting',
    component: ProfileSetting,
    beforeEnter: requireAuth
  },
  {
    path: '/visa_application',
    name: 'visaApplication',
    component: VisaApplication,
    beforeEnter: requireAuth
  },
  {
    path: '/news',
    name: 'news',
    component: News,
    beforeEnter: requireAuth
  },
  {
    path: '/news/:NID',
    name: 'newsDetail',
    component: NewsDetail,
    beforeEnter: requireAuth
  },
  {
    path: '/callback',
    name: 'callback',
    component: Callback
  },
  {
    path: '/termservice',
    name: 'termservice',
    component: TermService
  },
  {
    path: '/specificcommerce',
    name: 'specificcommerce',
    component: SpecificCommerce
  },
  {
    path: '/privacypolicy',
    name: 'privacypolicy',
    component: PrivacyPolicy
  },
  {
    path: '/qa',
    name: 'qa',
    component: Qa
  },
  {
    path: '/movie_list',
    name: 'MoveList',
    component: MoveList
  },
  {
    path: '/account_setting',
    name: 'account_setting',
    component: AccountSetting,
    beforeEnter: requireAuth
  },
  {
    path: '/email_setting',
    name: 'email_setting',
    component: EmailSetting,
    beforeEnter: requireAuth
  },
  {
    path: '/password_setting',
    name: 'password_setting',
    component: PasswordSetting,
    beforeEnter: requireAuth
  },
  {
    path: '/accept_certificate',
    name: 'accept_certificate',
    component: AcceptCertificate,
    beforeEnter: requireAuth
  },
  {
    path: '/resume_upload',
    name: 'resume_upload',
    component: ResumeUpload,
    beforeEnter: requireAuth
  },
  {
    path: '/study_text',
    name: 'study_text',
    component: StudyText,
    beforeEnter: requireAuth
  },
  {
    path: '/deactivate',
    name: 'deactivate',
    component: Deactivate,
    beforeEnter: requireAuth
  },
  {
    path: '/threads',
    name: 'threads',
    component: Boards,
    beforeEnter: requireAuth
  },
  {
    path: '/thread/:thread_id',
    name: 'thread_detail',
    component: BoardDetail,
    beforeEnter: requireAuth
  },


  // {
  //   path: '/cancel_subscription',
  //   name: 'cancel_subscription',
  //   component: CancelSubscription,
  //   beforeEnter: requireAuth
  // }
  ]},
  {
    path: "/seeker",
    component: JobService,

    children: [
    {
      path: '/job_mypage',
      name: 'JobMypage',
      component: JobMypage,
      beforeEnter: requireAuth
    },
    {
        path: '/job_how_to_use',
        name: "JobHowToUse",
        component: JobHowToUse,
        beforeEnter: requireAuth
    },
  {
    path: '/jobs',
    name: 'jobs',
    component: Jobs,
    beforeEnter: requireAuth
  },
  {
    path: '/jobs/search',
    name: 'jobssearch',
    component: JobsSearch,
    beforeEnter: requireAuth
  },
  {
    path: '/mailbox',
    name: 'mailbox',
    component: MailBox,
    beforeEnter: requireAuth
  },
  {
    path: '/seeker/resume',
    name: 'resume',
    component: Resume,
    beforeEnter: requireAuth
  },
  {
    path: '/seeker/interview',
    name: 'interview',
    component: SeekerInterview,
    beforeEnter: requireAuth
  },
  {
      path: '/jobs/:job_id',
    name: 'JobDetail',
    component: JobDetail,
    beforeEnter: requireAuth
  },
  {
      path: '/jobs/:job_id/application',
    name: 'ApplicationJob',
    component: ApplicationJob,
    beforeEnter: requireAuth
  },
  {
    path: '/recruits',
    name: 'recruits',
    component: Recruits,
    beforeEnter: requireAuth
  },

  ]},

  {path: "/organization",
  component: Organization,
  children: [
    {
      path: '',
      name: 'organizationTop',
      component: organizationTop,
    },
    {
      path: 'interviews',
      bame: 'Interview',
      component: Interview
    },
    {
      path: 'interviews/:uid',
      bame: 'Interview',
      component: UserInterview
    },
    {
      path: 'signin',
      name: 'org_sign',
      component: Signin,
    },
    {
      path: 'signup',
      name: 'org_signup',
      component: Signup,
    },
    {
      path: 'startup',
      name: 'org_startup',
      component: Startup,
      beforeEnter: requireOrgAuth
    },
    {
      path: 'mypage',
      name: 'org_mypage',
      component: OrgMypage,
      beforeEnter: requireOrgAuth
    },
    {
     path: 'jobOffer/create',
     name: 'org_create_joboffer',
     component: OrgCreateJobOffer,
     beforeEnter: requireOrgAuth
    },
    {
     path: 'jobOffer/:jobId/edit',
     name: 'org_job_edit',
     component: OrgCreateJobOffer,
     beforeEnter: requireOrgAuth
    },
    {
     path: 'jobOffer/:jobId',
     name: 'org_job',
     component: OrgJob,
     beforeEnter: requireOrgAuth
    },
    {
     path: 'jobOffers',
     name: 'org_joboffers',
     component: OrgJobOffers,
     beforeEnter: requireOrgAuth
    },
    {
     path: 'jobSeeker/:uId',
     name: 'org_jobseeker_detail',
     component: JobSeeker,
     beforeEnter: requireOrgAuth
    },
    {
     path: 'jobSeekerList',
     name: 'org_jobseeker_list',
     component: JobSeekerList,
     beforeEnter: requireOrgAuth
    },
    {
     path: 'favorites',
     name: 'favorites',
     component: Favorites,
     beforeEnter: requireOrgAuth
    },
    {
     path: 'applicantList',
     name: 'org_applicant_list',
     component: ApplicantList,
     beforeEnter: requireOrgAuth
    },
    {
     path: 'mail-box',
     name: 'mail-box',
     component: OrgMailBox,
     beforeEnter: requireOrgAuth
    },


    // {
    //  path: 'applicant/:uId',
    //  name: 'org_applicant',
    //  component: Applicant,
    // },
    {
     path: 'matchList',
     name: 'org_match_list',
     component: MatchList,
     beforeEnter: requireOrgAuth
    },
    {
     path: 'addOrganizationInfo',
     name: 'org_add_info',
     component: AddOrganizationInfo,
     beforeEnter: requireOrgAuth
    },
    {
     path: 'jobOffer/:jobId/preview',
     name: 'OrgJobPreview',
     component: OrgJobPreview,
     beforeEnter: requireOrgAuth
    },
    {
     path: 'agencyList',
     name: 'OrgAgenctList',
     component: AgencyList,
     beforeEnter: requireOrgAuth
    },
    {
     path: 'logout',
     name: 'OrgLogout',
     component: Logout,
     beforeEnter: requireOrgAuth
    },
  ]},

  {path: "/agency",
  component: Agency,
  children: [
    {
      path: '',
      name: 'agencyTop',
      component: AgencyTop,
    },
    {
      path: 'startup',
      name: 'agency_startup',
      component: AgencyStartup,
      beforeEnter: requireAgencyAuth
    },
    {
      path: 'mypage',
      name: 'agency_mypage',
      component: AgencyMypage,
      beforeEnter: requireAgencyAuth
    },
    {
      path: 'add_client',
      name: 'agency_create_link',
      component: CreateLink,
      beforeEnter: requireAgencyAuth
    },
    {
      path: 'client_list',
      name: 'agency_link_list',
      component: AgencyLinkList,
      beforeEnter: requireAgencyAuth
    },
    {
      path: 'jobOffers',
      name: 'agency_job_offers',
      component: OrgJobOffers,
      beforeEnter: requireAgencyAuth
    },
    {
     path: 'jobOffer/:jobId',
     name: 'agency_org_job',
     component: OrgJob,
     beforeEnter: requireAgencyAuth
    },
    {
     path: 'jobCreate',
     name: 'agency_create_joboffer',
     component: OrgCreateJobOffer,
     beforeEnter: requireAgencyAuth
    },
    {
     path: 'matchList',
     name: 'agency_match_list',
     component: MatchList,
     beforeEnter: requireAgencyAuth
    },
    {
     path: 'applicantList',
     name: 'agency_applicant_list',
     component: ApplicantList,
     beforeEnter: requireAgencyAuth
    },
    {
     path: 'jobSeekerList',
     name: 'agency_jobseeker_list',
     component: JobSeekerList,
     beforeEnter: requireAgencyAuth
    },
    {
     path: 'mail-box',
     name: 'agency-mail-box',
     component: OrgMailBox,
     beforeEnter: requireAgencyAuth
    },
    {
      path: 'interviews',
      bame: 'agency_interview',
      component: Interview,
      beforeEnter: requireAgencyAuth
    },
    {
     path: 'jobOffer/:jobId/edit',
     name: 'agency_job_edit',
     component: OrgCreateJobOffer,
     beforeEnter: requireAgencyAuth
    },
    {
     path: 'jobSeeker/:uId',
     name: 'agency_jobseeker_detail',
     component: JobSeeker,
     beforeEnter: requireAgencyAuth
    },
    {
     path: 'logout',
     name: 'agency_logout',
     component: AgencyLogout,
     beforeEnter: requireAgencyAuth
    },
    {
     path: 'users',
     name: 'users',
     component: AgencyUserList,
     beforeEnter: requireOrgAuth
    },
    {
     path: 'user/:id',
     name: 'user',
     component: AgencyUser,
     beforeEnter: requireOrgAuth
    },
    {
     path: 'users/import',
     name: 'user_import',
     component: AgencyUserImport,
     beforeEnter: requireOrgAuth
    },
    {
     path: 'favorites',
     name: 'favorites',
     component: Favorites,
     beforeEnter: requireOrgAuth
    },
   ]}
  ]
})
